const AlkyMationLogo = ({ addClass = '', width = 35, height = 35, color = '#4987be' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 128 128"
    role="img"
    aria-label="AlkyMation Logo"
    className={addClass}
  >
    <path
      d="M16 66 C38 40, 74 40, 96 66"
      fill="none"
      stroke={color}
      stroke-width="8"
      stroke-linecap="round"
    />
    <circle cx="16" cy="66" r="8" fill="#52c41a" stroke="#f0f0f0" stroke-width="2" />
    <circle cx="56" cy="66" r="11" fill="#ffffff" stroke={color} stroke-width="4" />
    <circle cx="96" cy="66" r="8" fill="#ff7875" stroke="#f0f0f0" stroke-width="2" />
  </svg>
);

export default AlkyMationLogo;
